import { useTranslation } from 'react-i18next';
import loadable from '@loadable/component';

const Footer = loadable(() => import('@com/footer/Footer'));
const FullSectionText = loadable(() => import('@com/FullSectionText'));
const Header = loadable(() => import('@com/header/Header'));
const LiveAuction = loadable(() => import('@com/layouts/home-6/LiveAuction'));
const TopSection = loadable(() => import('@com/TopSection'));

function NoResult() {
  const { t } = useTranslation();
  return (
    <div className="home-6">
      <Header />
      <TopSection />
      <FullSectionText>
        <div className="content-container">{t('noResult.noResults')}</div>
      </FullSectionText>
      <LiveAuction />
      <Footer />
    </div>
  );
}

export default NoResult;
